import axios from 'axios';

export const createPosOrder = async (cartId) => {
  const data = JSON.stringify({
    query: `mutation {
      CreatePosOrder(
        input: {
          cart_id: "${cartId}"
        }
      ) {
        message
        paymentLink
        status
        statusCode
      }
    }`,
    variables: {}
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/graphql',
    headers: { 
      'Content-Type': 'application/json', 
    },
    withCredentials: true,
    data: data
  };

  try {
    const response = await axios.request(config);
    console.log('POS order created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating POS order:', error);
    throw error;
  }
};
